module.exports = __webpack_public_path__ + "assets/img/00151.323c1f07.png";